<template>
	<section id="app" class="p-r p-l">
    	<router-view></router-view>		
	</section>
	
</template>

<script>
export default {  
}
</script>

